import React, { Component } from 'react';
import './Toast.css';

export default class Toast extends Component{
  render() {
    return <div className="toast" id={this.props.form}>{this.props.content}</div>
  }
}